import { render, staticRenderFns } from "./FastModify.vue?vue&type=template&id=a978d1c6&scoped=true&"
import script from "./FastModify.vue?vue&type=script&lang=js&"
export * from "./FastModify.vue?vue&type=script&lang=js&"
import style0 from "./FastModify.vue?vue&type=style&index=0&id=a978d1c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a978d1c6",
  null
  
)

component.options.__file = "FastModify.vue"
export default component.exports